"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var native_1 = __importDefault(require("styled-components/native"));
var ATLAtomLabel_1 = require("../atoms/ATLAtomLabel");
var ThemeProvider_1 = require("../theme/ThemeProvider");
var react_native_1 = require("react-native");
var TextBodyTypeEnum_1 = require("../enums/TextBodyTypeEnum");
var TextAlignmentEnum_1 = require("../enums/TextAlignmentEnum");
var defaultProps = {
    complementary: false,
    textAlignment: TextAlignmentEnum_1.TextAlignmentEnum.left,
    textBodyForm: false,
    type: TextBodyTypeEnum_1.TextBodyTypeEnum.b1,
    labelBaseProps: {}
};
// STYLED COMPONENTS ---------------------------------------------------------------------------------------------------
exports.TextWrapper = native_1.default(react_native_1.View)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tpadding:  ", "px\n\t          ", "px;\n"], ["\n\tpadding:  ", "px\n\t          ",
    "px;\n"
    // COMPONENT -----------------------------------------------------------------------------------------------------------
])), function (_a) {
    var atlTheme = _a.theme, props = __rest(_a, ["theme"]);
    return props.verticalMargin || atlTheme.SpacingBase;
}, function (_a) {
    var atlTheme = _a.theme, props = __rest(_a, ["theme"]);
    return props.horizontalMargin ||
        (props.textBodyForm ? atlTheme.SpacingInputMarginHorizontal : atlTheme.SpacingMarginal);
});
// COMPONENT -----------------------------------------------------------------------------------------------------------
exports.ATLTextBody = function (_a) {
    var children = _a.children, complementary = _a.complementary, textAlignment = _a.textAlignment, textBodyForm = _a.textBodyForm, horizontalMargin = _a.horizontalMargin, verticalMargin = _a.verticalMargin, type = _a.type, labelBaseProps = _a.labelBaseProps;
    var theme = ThemeProvider_1.useTheme();
    // Returns complete ATLTextBody
    return (react_1.default.createElement(exports.TextWrapper, { horizontalMargin: horizontalMargin, verticalMargin: verticalMargin, textBodyForm: textBodyForm },
        react_1.default.createElement(ATLAtomLabel_1.ATLAtomLabel, __assign({ fontFamily: theme.FontFamilySystem, fontSize: theme.FontSizeBody, fontWeight: type === TextBodyTypeEnum_1.TextBodyTypeEnum.b2 ? theme.FontWeightLight : theme.FontWeightNormal, lineHeight: theme.LineHeightBase, multilineLimit: theme.MultilineLimitBody, textColor: complementary ? theme.ColorComplementary1 : theme.ColorHighContrast, opacity: 1, textAlign: textAlignment }, labelBaseProps), children)));
};
exports.ATLTextBody.defaultProps = defaultProps;
exports.ATLTextBody.displayName = 'ATLTextBody';
var templateObject_1;
